module.exports = __webpack_public_path__ + "static/Simplebo-44affe3da9ad54a33f791c98359edf30.png";